import { DoubleSide } from 'three'
import { useRoofMeshes } from '~/components/DrawingCanvas/Roof/hooks/useRoofMeshes'
import { handleClick } from '~/components/DrawingCanvas/util/eventHandlers'
import { getRenderOrder } from '~/components/DrawingCanvas/util/renderOrder'
import { UNIT_CONVERSION_SCALAR } from '~/components/DrawingCanvas/util/units'
import LayerKeys from '~/config/layerKeys'
import ObjectClassName from '~/config/objectClassNames'
import theme from '~/config/theme'
import { useAppDispatch, useAppSelector } from '~/store/hooks'
import { selectObjects } from '~/store/selectedObjects'

export const Roof = () => {
  const roofMeshes = useRoofMeshes()
  const isVisible = useAppSelector(state => state.layers.layers.ROOFS.visible)
  const isSelected = useAppSelector(state => state.selectedObjects[0]?.className === ObjectClassName.ROOF)
  const dispatch = useAppDispatch()

  return (
    <>
      {roofMeshes.map(([id, mesh]) => {
        return (
          <group
            name={LayerKeys.ROOFS}
            visible={isVisible}
            onClick={handleClick(() => dispatch(selectObjects({ objects: [{ id, className: ObjectClassName.ROOF }] })))}
            scale={1 / UNIT_CONVERSION_SCALAR}
            key={id}
            renderOrder={getRenderOrder(LayerKeys.ROOFS)}
          >
            <lineSegments>
              <edgesGeometry args={[mesh.geometry]} />
              <lineBasicMaterial color={theme.colors.three.objects.roof.default} />
            </lineSegments>
            <primitive key={id} object={mesh}>
              <meshBasicMaterial
                color={theme.colors.three.objects.roof.default}
                transparent
                opacity={isSelected ? 0.6 : 0.4}
                side={DoubleSide}
                depthWrite={false}
              />
            </primitive>
          </group>
        )
      })}
    </>
  )
}
